'use strict';

var call = Function.prototype.call;
var $hasOwn = Object.prototype.hasOwnProperty;
var bind = require('function-bind');

/** @type {import('.')} */
module.exports = bind.call(call, $hasOwn);



//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/emr-webapp/~/hasown/index.js
// module id = ../../../../hasown/index.js
// module chunks = 5